import { Link } from '@remix-run/react'
import { SquarePlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { makeShopOwnPath } from '~/helpers/routes'
import { useShop } from '~/hooks/data/use-shop'
import { Button } from '~/ui'

export const CreateProductButton = () => {
  const { t } = useTranslation()
  const shop = useShop()

  return (
    <Button asChild size="lg" className="pointer-events-auto">
      <Link to={makeShopOwnPath(shop, '/products/create')}>
        <SquarePlusIcon className="opacity-64" />
        {t('action.create_product')}
      </Link>
    </Button>
  )
}
